export default __webpack_public_path__ + "static/media/One_Realme.da059ff5.png";